import { Component, input } from '@angular/core';
import { RouterButton } from '../router-button/model/router-button.model';

@Component({
  selector: 'c-card-item',
  standalone: false,
  templateUrl: './card-item.component.html',
  styleUrl: './card-item.component.css',
})
export class CardItemComponent {
  idCardItem = input<string>('');
  
  tituloHeader = input.required<string>();
  items = input<RouterButton[]>([]);
  
  small = input<boolean>(false);
}
